'use client'

import dynamic from 'next/dynamic'
import { Grid2 as Grid, Table, TableHead, TableBody, TableFooter, TableRow, TableCell, Alert } from '@mui/material'
import { Trans } from 'react-i18next'

// Types
import type { TransProps } from '@/types/components/atoms/trans'

// Componenets
const IconAtom = dynamic(() => import('@/components/atoms/icons'))
const ImageAtom = dynamic(() => import('@/components/atoms/image'))

const TransAtom = (props: TransProps) => {
	// Props
	const { components, children } = props

	return (
		<Trans
			components={{
				...{
					a: <a />,
					abbr: <abbr />,
					address: <address />,
					alert: <Alert severity="warning" />,
					area: <area />,
					article: <article />,
					aside: <aside />,
					audio: <audio />,
					b: <b />,
					base: <base />,
					bdi: <bdi />,
					bdo: <bdo />,
					big: <big />,
					blockquote: <blockquote />,
					body: <body />,
					br: <br />,
					button: <button />,
					canvas: <canvas />,
					caption: <caption />,
					center: <center />,
					cite: <cite />,
					code: <code />,
					col: <col />,
					colgroup: <colgroup />,
					data: <data />,
					datalist: <datalist />,
					dd: <dd />,
					del: <del />,
					details: <details />,
					dfn: <dfn />,
					dialog: <dialog />,
					div: <div />,
					dl: <dl />,
					dt: <dt />,
					em: <em />,
					embed: <embed />,
					fieldset: <fieldset />,
					figcaption: <figcaption />,
					figure: <figure />,
					footer: <footer />,
					form: <form />,
					grid: <Grid width="100%" />,
					h1: <h1 />,
					h2: <h2 />,
					h3: <h3 />,
					h4: <h4 />,
					h5: <h5 />,
					h6: <h6 />,
					header: <header />,
					hgroup: <hgroup />,
					hr: <hr />,
					html: <html />,
					i: <i />,
					iframe: <iframe />,
					input: <input />,
					ins: <ins />,
					kbd: <kbd />,
					keygen: <keygen />,
					label: <label />,
					legend: <legend />,
					li: <li />,
					link: <link />,
					main: <main />,
					map: <map />,
					mark: <mark />,
					menu: <menu />,
					menuitem: <menuitem />,
					meta: <meta />,
					meter: <meter />,
					nav: <nav />,
					noindex: <noindex />,
					noscript: <noscript />,
					object: <object />,
					ol: <ol />,
					optgroup: <optgroup />,
					option: <option />,
					output: <output />,
					p: <p />,
					param: <param />,
					picture: <picture />,
					pre: <pre />,
					progress: <progress />,
					q: <q />,
					rp: <rp />,
					rt: <rt />,
					ruby: <ruby />,
					s: <s />,
					samp: <samp />,
					search: <search />,
					slot: <slot />,
					script: <script />,
					section: <section />,
					select: <select />,
					small: <small />,
					source: <source />,
					span: <span />,
					strong: <strong />,
					style: <style />,
					sub: <sub />,
					summary: <summary />,
					sup: <sup />,
					table: <Table sx={{ borderWidth: 1 }} />,
					template: <template />,
					tbody: <TableBody />,
					td: <TableCell />,
					textarea: <textarea />,
					tfoot: <TableFooter />,
					th: <TableCell />,
					thead: <TableHead />,
					time: <time />,
					title: <title />,
					tr: <TableRow />,
					track: <track />,
					u: <u />,
					ul: <ul />,
					video: <video />,
					wbr: <wbr />,
					webview: <webview />,
					icon: <IconAtom />,
					img: <ImageAtom />
				},
				...(components ? components : {})
			}}
		>
			{children}
		</Trans>
	)
}

export default TransAtom
